"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getBucket = (API_ENV) => API_ENV === 'production'
    ? 'shine-163816.appspot.com'
    : 'shine-api-staging.appspot.com';
exports.default = {
    ACCRE: {
        canBeFilled: true,
        getUrl: ({ API_ENV, uid }) => `https://storage.googleapis.com/${getBucket(API_ENV)}/users/${uid}/shine_start/accre/${uid}.pdf`,
    },
    BIKE_DELIVERY_STATEMENT: {
        canBeFilled: true,
        url: 'https://storage.googleapis.com/shine-public/product/shine_start/templates/bike-delivery-statement.pdf',
    },
    CELIBACY_STATEMENT: {
        canBeFilled: true,
        url: 'https://storage.googleapis.com/shine-163816.appspot.com/public/shine_start/templates/CELIBACY_STATEMENT.pdf',
    },
    COMPANY_CERTIFICATE_OF_RESIDENCE: null,
    GENERIC: null,
    NO_CRIMINAL_CONVICTION_STATEMENT: {
        canBeFilled: true,
        url: 'https://storage.googleapis.com/shine-public/product/shine_start/templates/no-criminal-conviction-statement.pdf',
    },
    POWER_OF_ATTORNEY: {
        canBeFilled: true,
        url: 'https://storage.googleapis.com/shine-public/product/shine_start/templates/power-of-attorney.pdf',
    },
    PROOF_OF_IDENTITY_HAND_WRITTEN: {
        canBeFilled: false,
        url: 'https://storage.googleapis.com/shine-163816.appspot.com/public/shine_start/templates/PROOF_OF_IDENTITY_HAND_WRITTEN.jpg',
    },
};
